<script setup lang="ts">
import AppButton from '@/components/ui/AppButton.vue'
import Counter from '@/components/ui/Counter.vue'
import Loading from '@/components/ui/Loading.vue'
import { ref, onMounted } from 'vue'
import { createRemoteDiagnose } from '@/services/remote-diagnose'
import { useRemoteDiagnose } from '@/stores/remote-diagnose'
import { pinia } from '@/stores'
import { storeToRefs } from 'pinia'
import { getLimitDate, getTimeLeft, removeLimitDate, setLimitDate } from '@/utils/limit-date'
import { useRouterStore } from '@/stores/router'
import { setStore } from '@/utils/remote-diagnose'
import { cleanQueryString } from '@/utils/router'
import { useLang } from '@/composables/use-lang'
import PaymentContent from '@/lang/payment.json'
import RevolutCheckout, { type Mode } from '@revolut/checkout'

const props = defineProps({
  aws_url: {
    type: String,
    required: true
  },
  revolut_mode: {
    type: String,
    default: 'prod'
  }
})

const { push, resetParams } = useRouterStore(pinia)
const remoteDiagnoseStore = useRemoteDiagnose(pinia)

const { state } = storeToRefs(remoteDiagnoseStore)

const loading = ref<boolean>(true)
const loadingPay = ref<boolean>(false)
const error = ref<boolean>(false)
const revolutError = ref({
  status: false,
  message: ''
})
const revolut = ref<any>(null)
const cardholderName = ref<string>('')
const email = ref<string>('')

const emit = defineEmits(['scroll'])

const langContent = useLang(PaymentContent)

const handleSubmit = async () => {
  loadingPay.value = true

  revolut.value.submit({
    name: cardholderName.value,
    email: email.value
  })
}

const mountRevolutElements = async (result: any) => {
  const revolut_intance = await RevolutCheckout(
    result.payment_client_secret,
    props.revolut_mode as Mode
  )

  console.log({ revolut_intance })

  revolut.value = revolut_intance.createCardField({
    // target: document.getElementById('card-element')!,
    target: document.getElementsByTagName('remote-diagnose')[0].shadowRoot!.getElementById('card-element')!,
    locale: 'en-US',
    onSuccess() {
      console.log('success')
      const url = new URL(window.location.href)
      url.searchParams.set('redirect_status', 'succeeded')
      window.location.href = url.toString()
    },
    onError(error: Error) {
      revolutError.value.status = true
      revolutError.value.message = error.message
      loadingPay.value = false
    },
    onValidation(event: { message: string }[]) {
      if (!event.length) return
      revolutError.value.status = true
      revolutError.value.message = event[0].message
      loadingPay.value = false
    }
  })
}

onMounted(async () => {
  emit('scroll')
  cleanQueryString()

  // validate if the time already expired and redirect it to timesup page
  const limitDate = getLimitDate()
  if (limitDate) {
    const timeLeft = getTimeLeft(limitDate)
    console.log({ timeLeft })
    if (timeLeft <= 0) {
      removeLimitDate()
      push('timesup')
      return null
    }
  }

  if (state.value.phone_number) {
    resetParams()
    const result = await createRemoteDiagnose(state.value, props.aws_url)

    //  set error if create payment failed
    if (!result.payment_client_secret) {
      error.value = true
      loading.value = false
      return null
    }

    //set current state in local storage
    setStore(state.value)
    loading.value = false

    //set limit date for counter
    setLimitDate(result.created_at)

    mountRevolutElements(result)
  } else {
    loading.value = false
    removeLimitDate()
    push('home')
  }
})
</script>

<template>
  <div v-if="langContent">
    <div v-if="error">
      <p class="text-sweet-brown">{{ langContent.error_message }}</p>
    </div>
    <Loading v-if="loading && !error" />
    <form @submit.prevent="handleSubmit">
      <counter v-if="!loading" />
      <div class="flex flex-col items-center gap-4 max-w-lg mx-auto">
        <input type="text" placeholder="Card Holder Name" v-model="cardholderName" />
        <input type="email" placeholder="Email" v-model="email" />
        <div id="card-element" class="mw-full px-3 py-2 rc-card-field rc-card-field--empty"></div>
        <p v-if="revolutError.status" class="text-sweet-brown">{{ revolutError.message }}</p>
        <app-button
          v-if="!loading"
          id="submit"
          type="submit"
          class="mt-8"
          :loading="loadingPay"
          :disabled="loadingPay"
          >Pay Now</app-button
        >
      </div>
    </form>
  </div>
</template>
